export default __webpack_public_path__ + "static/media/factory__37.9a4a27ec.jpg";